import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DateRangePicker } from "react-date-range";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import { format } from "date-fns";
import "./overview.css";
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../services/endpoint/endPoint";
import PartnersDetail from "./childs/PartnersDetail";
import DataListing from "./childs/DataListing";
import button from "../../../button.module.css";
import MultiselectCheckbox from "../../../common/multiselect-checkbox/MultiselectCheckbox";
import { MonthPicker } from "@mantine/dates";

const SupplyOverview = () => {
  let userCurrency = JSON.parse(localStorage.getItem("user"));
  let clientName = localStorage.getItem("clientName");
  let { clientId } = useParams();
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const firstDayOfYear = new Date(new Date().getFullYear(), 0, 1);
  const [fileFormat, setFileFormat] = useState({ name: "CSV", id: "csv" });
  const [partnerInfo, setPartnerInfo] = useState([]);
  const [durationType, setDurationType] = useState("daily");
  const [privillage, setPrivillage] = useState([]);
  const [cardWidth, setCardWidth] = useState();
  const [partnerId, setPartnerId] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [currency, setCurrency] = useState(
    userCurrency?.currency != "ALL" ? userCurrency.currency : "USD"
  );
  const [toggleCalander, setToggleCalander] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: firstDayOfMonth,
    endDate: currentDate,
    key: "selection",
  });
  const [monthRange, setMonthRange] = useState([firstDayOfYear, currentDate]);
  const [applyDateRange, setApplyDateRange] = useState(dateRange);

  const [sortingColumn, setSortingColumn] = useState("");
  const [sortingOrder, setSortingOrder] = useState("dsc");

  const isCalanderShow = useRef(null);
  const calanderValue = useRef(null);

  const [graphData, setGraphData] = useState([]);
  const [singleGraphList, setSingleGraphList] = useState([]);

  const [loader, setLoader] = useState(false);

  const [singleGraphId, setSingleGraphId] = useState();

  const [showHideModal, setShowHideModal] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [privilegeList, setPrivillageList] = useState([]);
  const [selectedPrivilege, setSelectedPrivilege] = useState([]);

  const handleMonthChange = (newRange) => {
    setMonthRange(newRange);
  };

  const getPartnerData = () => {
    const data = {
      startDateRange: `${format(applyDateRange.startDate, "MM/dd/yyyy")}`,
      endDateRange: `${format(applyDateRange.endDate, "MM/dd/yyyy")}`,
      supply_partner_id: `${partnerId}`,
      currency: `${currency}`,
      clientId: clientId ? clientId : null,
    };

    ApiCallServices.create(END_POINTS.partnerData, data)
      .then((res) => {
        const data = res.data.data;
        if (res.status === 200) {
          setPartnerInfo(data.cardData);
          setPrivillage(data.privillage);
          if (data.cardData.length > 1 || data.cardData.length < 5) {
            const width = 96 / data.cardData.length;
            setCardWidth(width);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const handleChildData = (partner_id) => {
    if (partner_id) {
      setPartnerId(partner_id);
    } else {
      setPartnerId(0);
    }
  };

  const getPartnerTableList = () => {
    setLoader(true);
    const data = {
      startDateRange: `${format(applyDateRange.startDate, "MM/dd/yyyy")}`,
      endDateRange: `${format(applyDateRange.endDate, "MM/dd/yyyy")}`,
      supply_partner_id: `${partnerId}`,
      currency: `${currency}`,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
      clientId: clientId ? clientId : null,
    };
    ApiCallServices.create(END_POINTS.partnerTableData, data)
      .then((res) => {
        let resp = res.data.data;
        if (res.status === 200) {
          setTableData(resp);
          setLoader(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  useEffect(() => {
    getPartnerTableList();
  }, [
    partnerId,
    applyDateRange,
    currency,
    sortingColumn,
    sortingOrder,
    clientId,
  ]);

  useEffect(() => {
    getPartnerData();
  }, [applyDateRange, currency, clientId]);

  const handleCurrency = (e) => {
    setCurrency(e.target.value);
    // setCurrency(selectedCurrency);
  };
  const handleDurationType = (e) => {
    setDurationType(e.target.value);
  };

  const handleCalanderToggle = () => {
    setToggleCalander((prev) => !prev);
  };

  const handleDateChange = (ranges) => {
    setDateRange(ranges.selection);
  };

  const applyDateFilter = () => {
    if (durationType === "monthly") {
      const startMonth = new Date(monthRange[0]); // First month selected
      const endMonth = monthRange[1] ? new Date(monthRange[1]) : startMonth; // Second month or duplicate first

      const startDate = new Date(
        startMonth.getFullYear(),
        startMonth.getMonth(),
        1
      ); // 1st of the start month
      const endDate = new Date(
        endMonth.getFullYear(),
        endMonth.getMonth() + 1,
        0
      ); // Last day of the end month

      setApplyDateRange({
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      });
    } else {
      setApplyDateRange(dateRange);
    }
    // setApplyDateRange(dateRange);
    setToggleCalander(false);
  };

  const handleSort = (column) => {
    const order =
      sortingColumn === column && sortingOrder === "asc" ? "desc" : "asc";
    setSortingColumn(column);
    setSortingOrder(order);
  };

  const handleClickOutSide = (e) => {
    if (
      isCalanderShow?.current &&
      !isCalanderShow?.current.contains(e.target) &&
      calanderValue?.current &&
      !calanderValue?.current.contains(e.target)
    ) {
      setToggleCalander(false);
    }
  };
  document.addEventListener("click", handleClickOutSide);

  const goBackOnOverview = () => {
    navigate("/");
  };

  const getGraphData = () => {
    let data = {
      startDateRange: `${format(applyDateRange.startDate, "MM/dd/yyyy")}`,
      endDateRange: `${format(applyDateRange.endDate, "MM/dd/yyyy")}`,
      clientId: clientId ? clientId : null,
      currency: `${currency}`,
      durationType: durationType,
    };
    ApiCallServices.create(END_POINTS.reportGraph, data)
      .then((res) => {
        let resp = res.data.data.data;
        if (res.status == 200) {
          setGraphData(resp.cardData);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const SingleGraphData = (id) => {
    // setSingleGraphId(id);
    if (id && id !== undefined) {
      setPartnerId(id);
    }

    let data = {
      startDateRange: `${format(applyDateRange.startDate, "MM/dd/yyyy")}`,
      endDateRange: `${format(applyDateRange.endDate, "MM/dd/yyyy")}`,
      supply_partner_id: id ? id : 0,
      clientId: clientId ? clientId : null,
      currency: `${currency}`,
    };
    ApiCallServices.create(END_POINTS.expandGraph, data)
      .then((res) => {
        let resp = res.data.data.data;
        if (res.status == 200) {
          setSingleGraphList(resp.tableData);
          if (id) {
            setPartnerId(id);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  useEffect(() => {
    getGraphData();
  }, [applyDateRange, clientId, currency]);

  useEffect(() => {
    SingleGraphData();
  }, [applyDateRange, clientId, currency]);

  const downloadCSV = async () => {
    const selectedColumns = selectedPrivilege?.map((item) => item.label);
    const startDateFormatted = format(applyDateRange.startDate, "MM_dd_yyyy");
    const endDateFormatted = format(applyDateRange.endDate, "MM_dd_yyyy");
    const fileExt = fileFormat?.id || "csv";
    const fileName = `supply_partner_report_${startDateFormatted}_to_${endDateFormatted}.${fileExt}`;
  
    const data = {
      startDateRange: format(applyDateRange.startDate, "MM/dd/yyyy"),
      endDateRange: format(applyDateRange.endDate, "MM/dd/yyyy"),
      supply_partner_id: selectedPartner?.id || 0,
      clientId: clientId || null,
      currency: currency,
      columns: selectedColumns,
    };
  
    try {
      const response = await ApiCallServices.create(
        `${END_POINTS.partnerTableData}?downloadCSV=true&fileformat=${fileExt}`,
        data,
        {
          responseType: "blob",
        }
      );
  
      if (response.status === 200) {
        const mimeType =
          fileExt === "xlsx"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "text/csv";
  
        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
  
        // Cleanup modal + reset
        document.body.removeAttribute("style");
        setShowHideModal(false);
        setSelectedPrivilege(null);
        setSelectedPartner(null);
      } else {
        console.error("Failed to download file");
        toast.error("Failed to download report.");
      }
    } catch (error) {
      console.error("Error during file download:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  

  const handleHideShowModal = () => {
    setShowHideModal(true);
    document.body.style = "overflow: hidden";
  };

  const handleFormReset = () => {
    setShowHideModal(false);
    document?.body?.removeAttribute("style");
  };

  const getPartnerList = () => {
    ApiCallServices.getlisting(END_POINTS.csvSupplyPartner)
      .then((res) => {
        if (res.status == 200) {
          setPartnerList(res.data.data);
        }
      })
      .catch((error) => {
        // Handle errors here
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  useEffect(() => {
    getPartnerList();
  }, []);

  const handleSelectChange = (selectedValue) => {
    setSelectedPartner(selectedValue);
  };
  const handleSelectFileFormat = (fileFormat) => {
    console.log(fileFormat);
    setFileFormat(fileFormat);
  };

  const handlePrivilegeChange = (value) => {
    setSelectedPrivilege(value);
  };

  const getPrevilagesList = () => {
    let data = {
      userId: user?.id,
    };
    ApiCallServices.create(END_POINTS.privilegeList, data)
      .then((res) => {
        let resp = res.data.data;
        if (res.status === 200) {
          let resArr = [];
          resp.privilege.split(",").map((item, i) => {
            return resArr.push({ value: i, label: item });
          });
          setPrivillageList(resArr);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };
  useEffect(() => {
    getPrevilagesList();
  }, []);

  // const adomainList = (id) => {
  //   console.log(id, "****idd")
  //   let data = {
  //     // startDateRange: "11/01/2023",
  //     // endDateRange: "11/27/2024",
  //     // tr_deal_id: "12"
  //       startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
  //       endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
  //       tr_deal_id: id,
  //   }
  //    ApiCallServices.create(END_POINTS.adomainList, data).then((res) => {
  //       if(res.status == 200){
  //           console.log(res, "*****")
  //           setAdomain(res.data.data.data)
  //       }
  //   })
  //   .catch((error) => {
  //       // Handle errors here
  //       if (error.response) {
  //           toast.error(error.response.data.error, {
  //               position: "top-right"
  //           });
  //           console.log(error.response, "===>error in getting response");
  //       }
  //   });
  // }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#fff"
        : state.isFocused
        ? "#6abfe94d"
        : undefined,
      color: state.isSelected ? "#000" : "black",
      padding: 10,
      display: "flex",
      alignItems: "center",
    }),
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="filter-wraper overview">
          {clientId && (
            <h4 className="client-report-head">
              {" "}
              Client Report : {clientName}{" "}
              <i
                class="fa-regular fa-circle-xmark"
                onClick={goBackOnOverview}
              ></i>
            </h4>
          )}
          {userCurrency.currency == "ALL" ? (
            <div className="form-group currency-select">
              <i className="fa-solid fa-angle-down drop"></i>
              <select
                className="form-control"
                value={currency}
                onChange={handleCurrency}
              >
                <option value="INR">INR </option>
                <option value="USD">USD </option>
                <option value="CAD">CAD </option>
                <option value="EUR">EUR </option>
                {/* <option value="BASE">Base </option> */}
              </select>
            </div>
          ) : (
            <span className="currency-box">{userCurrency.currency}</span>
          )}
          <div className="d-flex">
            <div className="form-group currency-select">
              <i className="fa-solid fa-angle-down drop"></i>
              <select className="form-control" onChange={handleDurationType}>
                <option value="daily"> Daily </option>
                <option value="monthly"> Monthly </option>
              </select>
            </div>

            <div className="form-group date-range-block">
              <i className="fa-solid fa-angle-down drop"></i>
              <input
                type="text"
                className="form-control"
                id="calander_field"
                value={`${format(
                  applyDateRange.startDate,
                  "MMM-dd-yyyy"
                )} - ${format(applyDateRange.endDate, "MMM-dd-yyyy")}`}
                onClick={handleCalanderToggle}
                ref={calanderValue}
                readOnly
              />
              {toggleCalander && (
                <div className="custom-date-range" ref={isCalanderShow}>
                  {durationType == "monthly" ? (
                    <MonthPicker
                      type="range"
                      maxDate={new Date()}
                      numberOfColumns={2}
                      allowSingleDateInRange
                      value={monthRange}
                      onChange={(range) => handleMonthChange(range)}
                    />
                  ) : (
                    <DateRangePicker
                      ranges={[dateRange]}
                      maxDate={new Date()}
                      onChange={handleDateChange}
                    />
                  )}
                  <button
                    type="button"
                    className={`date-btn ${button.btn} ${button.btnBlue}`}
                    onClick={applyDateFilter}
                  >
                    Apply
                  </button>
                </div>
              )}
            </div>
            {/* <button onClick={downloadCSV}>
                Download CSV
            </button> */}
            <i
              style={{
                marginLeft: "10px",
                fontSize: "25px",
                marginTop: "5px",
                color: "#0a58ca",
                cursor: "pointer",
              }}
              class="fa-solid fa-download"
              onClick={handleHideShowModal}
            ></i>
          </div>
        </div>
        <div className="row">
          <PartnersDetail
            patrners={partnerInfo}
            SingleGraphData={SingleGraphData}
            singleGraphList={singleGraphList}
            graphData={graphData}
            privillage={privillage}
            width={cardWidth}
            patrnerId={handleChildData}
            currency={currency}
          />
        </div>
        {/* <Graph /> */}
        <DataListing
          patrners={partnerInfo}
          loader={loader}
          tableData={tableData}
          onSort={handleSort}
          sortingColumn={sortingColumn}
          sortingOrder={sortingOrder}
          applyDateRange={applyDateRange}
          handleCurrencyChange={setCurrency}
          currency={currency}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Select partner(s) for download report
              </h4>
              <i
                class="fa-regular fa-circle-xmark close-icon"
                onClick={handleFormReset}
              ></i>
            </div>

            <div className="modal-body">
              {/* <form onSubmit={handleSubmit}> */}
              <div className="form-wraper">
                <div className="form-group custome-select">
                  <label>Supply Partner </label>
                  <Select
                    value={selectedPartner}
                    onChange={handleSelectChange}
                    options={partnerList}
                    defaultValue={partnerList}
                    getOptionLabel={(partnerList) => partnerList.name}
                    getOptionValue={(partnerList) => partnerList.id}
                  />
                </div>
                <div className="form-group custome-select multicheck">
                  <label> Column's</label>
                  <Select
                    placeholder="Select Column's"
                    isClearable="true"
                    isMulti={true}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    value={selectedPrivilege}
                    onChange={handlePrivilegeChange}
                    options={privilegeList}
                    components={{ Option: MultiselectCheckbox }}
                    styles={customStyles}
                  />
                </div>
                <div className="form-group custome-select">
                  <label>File Format </label>
                  <Select
                    value={fileFormat}
                    onChange={handleSelectFileFormat}
                    options={[
                      { name: "XLSX", id: "xlsx" },
                      { name: "CSV", id: "csv" },
                    ]}
                    getOptionLabel={(partnerList) => partnerList.name}
                    getOptionValue={(partnerList) => partnerList.id}
                  />
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    className={`${button.btn} ${button.btnBlue}`}
                    onClick={downloadCSV}
                  >
                    Download
                  </button>
                </div>
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
      <div className={`${showHideModal ? "overlay" : ""}`}></div>
    </>
  );
};

export default SupplyOverview;